import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AdditionalFolderAutomationDrawer from '@/components/Drawers/AdditionalFolderAutomationDrawer';
import { closeDialog } from '@/features/dialog/dialogSlice';
import { AUTOMATION_NAMES } from '@/utils/automationCatalog';

// Add a drawer here when an automation gets a configuration screen...
const AUTOMATION_CONFIG_DRAWERS = {
	[AUTOMATION_NAMES.additionalFolderCreation]: AdditionalFolderAutomationDrawer,
};

export const hasAutomationConfigDrawer = (name) => Boolean(AUTOMATION_CONFIG_DRAWERS[name]);

const AutomationConfigDrawer = () => {
	const dispatch = useDispatch();
	const open = useSelector((state) => state.dialog?.open?.automation) ?? false;
	const name = useSelector((state) => state.dialog?.data?.automation?.name);

	if (!name) return null;

	const ConfigDrawer = AUTOMATION_CONFIG_DRAWERS[name];
	if (!ConfigDrawer) return null;

	return (
		<ConfigDrawer
			open={open}
			onClose={() => dispatch(closeDialog('automation'))}
		/>
	);
};

export default AutomationConfigDrawer;